import './scss/main.scss';

import { createApp } from 'vue';
import App from './App.vue';
import i18n from './i18n';
import { createVuestic } from 'vuestic-ui';

import stores from './stores';
import router from './router';
import vuesticGlobalConfig from './services/vuestic-ui/global-config';
import './permission';

const app = createApp(App);

app.use(stores);
app.use(router);
app.use(i18n);
app.use(createVuestic({ config: vuesticGlobalConfig }));

app.mount('#app');
